<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
<div class="card crd p-3">
    <div class="row">
        <div class="col-md-10 col10">
            <h5><b>Generating a payment link via the dashboard.</b></h5>
            <label for="">The animated GIF illustrates the process of generating a payment
                link directly from the dashboard.</label>
        </div>
        <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
            alt=""> </button> </a></div>
        <div class="col-md-12 mt-3">
            <img src="./assets/GIF/Creating Payment link GIF.gif" width="95%" height="95%"
                alt="" style="border-radius: 10px;">
        </div>

        <div class="col-md-10 col10 mt-2">
            <h2 >How to Create Payment link</h2>
           
        </div>

        <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
            (mouseout)="showpayment(false,'1')" id='13'>
            <div
                style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                <iframe
                    class="i-frame"
                    src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>
        </div> -->
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2') "
            (mouseout)="showpayment(false,'2')" id="14">
            <h3 >Creating a payment link in PayG typically involves the
                following steps:
                <br><br>

                On the web
            </h3>
          
            <ol class="mt-3">
                <li >Sign in to the PayG dashboard, then click on the
                    “Create” button and
                    then
                    “Payment
                    link”. </li>
              
                <div class="row">
                    <div class="col-md-12 mt-4">
                        <img src="./assets/1.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/2.png" width="100%" height="100%" alt="">
                    </div>
                </div>
                <li class="mt-5" >Enter the required details and then click
                    on “Create
                    payment
                    link”.
                </li>
              

                <div class="row">
                    <div class="col-md-12 mt-4">
                        <img src="./assets/3.png" width="100%" height="80%" alt="">
                    </div>

                </div>
                <li class="mt-2" >A confirmation message will be shown on the
                    screen and the
                    page
                    will be
                    redirected to the next page where you can check your details again and
                    if
                    you
                    want
                    to allow partial payments, you can check the box given. </li>
               
                <div class="row">

                    <div class="col-md-12 mt-3 ">
                        <img src="./assets/4.png" width="100%" height="100%" alt="">
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/5.png" width="100%" height="100%" alt="">
                    </div>
                </div>

                <li class="mt-4" >The link will be sent directly to the
                    customer's mobile
                    phone,
                    or
                    you
                    can copy it and send it to customers via email or other chat
                    applications.
                </li>
               
            </ol>
        </div>
        <div class="col md-12 mt-4" (mouseover)="showpayment(true,'3')"
            (mouseout)="showpayment(false,'3')" id="15">
            <h5 >On the mobile app: </h5>
            <ul>
                <li class="mt-5" >
                    After signing in, click on the "+" button, which is located at the
                    bottom
                    right
                    of
                    the screen, and select the first option which is “Payment Link”
                </li>
              
                <div class="row">
                    <div class="col-md-12 mt-3 text-center">
                        <img src="./assets/create1.png" alt="" width="40%" height="65%">
                    </div>
                </div>
                <li class="mt-3" >
                    You can select either of the options given “Create a detailed payment
                    link”
                    or
                    “Create an Instant payment link”.
                </li>
                
                <div class="row">
                    <div class="col-md-12 mt-3 text-center">
                        <img src="./assets/Selected photo (6).jpg" alt="" width="50%"
                            height="65%">
                    </div>
                </div>
                <li class="     " >The name, email, and mobile number of the
                    customer can all
                    be
                    included
                    in a detailed payment link, allowing for a great level of
                    personalization.
                    Also
                    included are the payment's purpose and the link's expiration date and
                    time.
                    The
                    smooth payment experience that results from this modification is
                    consistent
                    with
                    the
                    merchant's website or brand identification. You can manage your links as
                    well in
                    this section. </li>
                <div class="row">
                    <div class="col-md-12 mt-3 text-center">
                        <img src="./assets/Selected photo (7).jpg " alt="" width="50%"
                            height="65%">
                    </div>
                </div>
                <li >A quick payment link is designed for a more
                    straightforward and faster
                    payment
                    experience. It aims to minimize the steps and information required from
                    the
                    customer
                    during the payment process. It simply includes the name of the customer,
                    amount,
                    and
                    link expiry date. You can manage your links in this section also. </li>
             
                <div class="row">
                    <div class="col-md-12 mt-3 text-center">
                        <img src="./assets/Selected photo (8).jpg " alt="" width="50%"
                            height="65%">
                    </div>
                </div>
            </ul>
        </div>
    </div>
</div>
</div>
<div class="col-md-4  hide-tbl content2 ">
<div class="card crd p-4">
    <div class="row">
        <div class="col-md-12">
            <h5 >
                Table of Contents:
            </h5>
         
        </div>
        <!-- <div class="col-md-12 mt-2">
            <a href="#13"> <div class="row">
                <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                        alt=""> &nbsp;</div>
                <div class="col-md-10">
                    <span style="cursor: pointer;" class="videoHover"
                        [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                        Creating it on the web </span>
                </div>
            </div></a>
        </div> -->
        <div class="col-md-12 mt-2">
            <a href="#14">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                            >
                            Creating it on the web </span>
                   
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-2">
            <a href="#15">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                            >Creating
                            it on
                            PayG mobile app </span>
                        
                    </div>
                </div>
            </a>
        </div>


    </div>
</div>
</div>
<div class="col-md-9 hide ft-9">
    <hr>
    <div class=" row crd">
        <div class="col-md-8">
            <a [routerLink]="['/payment-link']"> <button class="btn btn-color" (click)="menues('Payment Link')" > <img
                    src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Payment Link
            </button></a>
      
        </div>
        <div class="col-md-4  ">
            <a [routerLink]="['/g-store']"><button class="btn btn-color" (click)="menues('G-Store')" >G-Store
                &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
          
        </div>
    </div>
</div>
</div>